import React from 'react';
import { DPage, DPageBody } from '../../../../dum';
import { OrderRequestsListBlock } from './blocks/order-requests-list-block';

export function OrderRequestsPage() {
    return (
        <DPage>
            <DPageBody disableGutters>
                <OrderRequestsListBlock />
            </DPageBody>
        </DPage>
    );
}
